<template>
  <div>
    <ui-dialog heading="Bestätigung" @cancel="$emit('cancel')">
      <div class="-mb-2 text-medium">
        <slot></slot>
      </div>
      <template slot="footer">
        <ui-button @click.native="$emit('cancel')" tertiary> Nein </ui-button>
        <ui-button @click.native="$emit('confirm')"> Ja </ui-button>
      </template>
    </ui-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import UiButton from "./UiButton.vue";
import UiDialog from "./UiDialog.vue";

export default Vue.extend({
  components: {
    UiButton,
    UiDialog
  }
});
</script>
